/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { __assign } from "tslib";
import { ParamDefinition as PD } from '../../../mol-util/param-definition';
import { ColorNames } from '../../../mol-util/color/names';
import { Text } from '../../../mol-geo/geometry/text/text';
export var MeasurementRepresentationCommonTextParams = {
  customText: PD.Text('', {
    label: 'Text',
    description: 'Override the label with custom value.'
  }),
  textColor: PD.Color(ColorNames.black, {
    isEssential: true
  }),
  textSize: PD.Numeric(0.5, {
    min: 0.1,
    max: 5,
    step: 0.1
  }, {
    isEssential: true
  })
};
export var LociLabelTextParams = __assign(__assign(__assign({}, Text.Params), MeasurementRepresentationCommonTextParams), {
  borderWidth: PD.Numeric(0.2, {
    min: 0,
    max: 0.5,
    step: 0.01
  })
});